import { login,PhoneLogin, logout, getUserInfo, wxLogin, wxPhoneLogin } from "@/api";
import { U_STORE } from "../types";

export default {
  state: {},
  mutations: {},
  actions: {
    async LoginByUsername({ dispatch }, params) {
      const res = await login(params);
      return dispatch("LoginSuccess", res);
    },
    async wxLogin({ dispatch }, params = {}) {
      if (!params.code) {
        params.code = await dispatch("wxLoginCode");
      }

      params.appid = "xddtest";

      const res = await wxLogin(params);
      return dispatch("LoginSuccess", res);
    },
    LoginSuccess({ dispatch, commit }, res) {
      commit(U_STORE, { name: "vuex_token", value: res.token });
      uni.$emit("user:login_success", res);
      return dispatch("GetUserInfo");
    },
    async wxPhoneLogin({ dispatch }, { phoneCode }) {
      const code = await dispatch("wxLoginCode");
      var res = await wxPhoneLogin({ phoneCode, code });
      return dispatch("LoginSuccess", res);
    },
    // 获取用户信息
    async GetUserInfo({ commit }) {
      const data = await getUserInfo();
      commit(U_STORE, { name: "vuex_user", value: data });
      commit(U_STORE, { name: "vuex_authorities", value: data.authorities ||[] });
      return data;
    },
    // 登出
    async Logout({ commit }) {
      try {
        if (process.env.VUE_NODE_ENV == "prod") {
          await logout();
        }
      } catch (e) {
        console.log("e", e);
      } finally {
        commit("CLEAR_DICT_LIST");
        commit(U_STORE, { name: "vuex_user", value: {} });
        commit(U_STORE, { name: "vuex_token", value: "" });
        commit(U_STORE, { name: "vuex_authorities", value: [] });
      }
    }
  }
};
